// What the visitor has been reading, kept in their own browser only (localStorage). We send the resulting topic
// words to /api/recommend to pick what to show next; no identifiers, no server-side profile.
const KEY = 'amm_interest_v1';
const MAX_TOPICS = 24;
const MAX_SEEN = 40;
const STOP = new Set(['the', 'a', 'an', 'and', 'or', 'of', 'for', 'to', 'in', 'on', 'with', 'your', 'you', 'how',
  'what', 'why', 'is', 'are', 'best', 'top', 'guide', 'review', 'vs', 'new', 'latest', '2026', '2025', 'india']);

function read() {
  try { return JSON.parse(localStorage.getItem(KEY)) || { topics: {}, seen: [] }; }
  catch { return { topics: {}, seen: [] }; }
}
function write(state) {
  try { localStorage.setItem(KEY, JSON.stringify(state)); } catch { /* private mode: recommendations just stay generic */ }
}

// Call when an article page opens. Weighs category and tags above title words.
export function recordArticleView(article) {
  if (!article?.id) return;
  const state = read();
  const add = (word, weight) => {
    const w = String(word || '').toLowerCase().trim();
    if (!w || w.length < 3 || STOP.has(w)) return;
    state.topics[w] = (state.topics[w] || 0) + weight;
  };
  add(article.category, 3);
  (article.tags || []).slice(0, 4).forEach((t) => String(t).split(/[\s,]+/).forEach((w) => add(w, 2)));
  String(article.title || '').split(/[^A-Za-z0-9'+-]+/).slice(0, 12).forEach((w) => add(w, 1));

  // decay so last week's obsession does not outrank today's
  Object.keys(state.topics).forEach((k) => { state.topics[k] *= 0.97; if (state.topics[k] < 0.4) delete state.topics[k]; });
  state.topics = Object.fromEntries(Object.entries(state.topics).sort((a, b) => b[1] - a[1]).slice(0, MAX_TOPICS));
  state.seen = [article.id, ...state.seen.filter((id) => id !== article.id)].slice(0, MAX_SEEN);
  write(state);
}

export function topTopics(n = 6) {
  return Object.entries(read().topics).sort((a, b) => b[1] - a[1]).slice(0, n).map(([w]) => w);
}

export function seenIds(n = 20) {
  return read().seen.slice(0, n);
}

export function hasInterest() {
  return topTopics(1).length > 0;
}
